import React, { useContext, useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom";
import Icon from "../../../Assets/Images/Souvenir/Icons/auction.png";
import noImage from "../../../Assets/Images/settings/no-image.png";

import { Markup } from "interweave";
import { LocationContext } from "../../../CustomHelper/Helper";
import AuctionModal from "../../Modal/AuctionModal";
import NodataAvailable from "../../Common/NodataAvailable";
import { serverInfo } from "../../../App";
const AuctionsTab = ({ user }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [modalShow, setModalShow] = React.useState(false);
  const [modalData, setModalData] = useState("");

  const { trackCurrencyValue, setTrackCurrencyValue } =
    useContext(LocationContext);
  const { trackCurrencySymbol, setTrackCurrencySymbol } =
    useContext(LocationContext);

  const bidEnd = new Date(user.bid_to).getTime();
  const currentTime = new Date().getTime();

  const openModal = (data) => {
    setModalShow(true);
    setModalData(data);
  };

  const { slectedCurrency, payStatus } = useContext(LocationContext);

  const handelCuntrybasePrice = (fee) => {
    return (Number(fee) * Number(slectedCurrency?.currency_value)).toFixed(0);
  };

  return (
    <>
      {user.length === 0 ? (
        <NodataAvailable />
      ) : (
        <div className="card card-bg1 p-3 mb-2">
          <div className="bg-adrk p-3 card AuctionsA  ">
            <div className=" row TabMar">
              <div className="col-md-6">
                <OwlCarousel
                  items={1}
                  loop
                  autoplay
                  autoplayTimeout={3000}
                  margin={0}
                  dots={false}
                >
                  <img
                    src={imageCdnUrl + user.product_image}
                    alt=""
                    className="img-fluid AuctionsImg "
                  />
                </OwlCarousel>
              </div>

              <div className="col-md-6 containerAuc px-3">
                <div className="w-100">
                  <h3> {user.title}</h3>
                  <p className="text-light ">
                    <Markup content={user.details.substring(0, 50)}></Markup>
                  </p>

                  <div className="text-light ">
                    <span className="DollarPrice fw-bold"> Base Price : 
                      {handelCuntrybasePrice(user?.base_price)}
                    </span>
                    &nbsp;
                    <small className="text-light ">
                      {" " + slectedCurrency?.symbol}
                    </small>
                  </div>
                  <div className="d-flex mt-2 JerseyAucPro w-100 justify-content-between">
                    <div className="d-flex">
                      <img
                        src={
                          user?.star?.image !== null
                            ? imageCdnUrl + user?.star?.image
                            : noImage
                        }
                        className="AuctionProImg img-fluid"
                        alt="star-profile"
                      />
                      <span className="mx-2 mt-1 SpanAu">
                        <Link to={`/starprofile/${user?.star?.id}`}>
                          {" "}
                          <h5 className="proTextAc pt-3">
                            {user?.star?.first_name}
                            {user?.star?.last_name}
                          </h5>
                        </Link>
                      </span>
                    </div>

                    <div className="BestPrice"> Base Price : {handelCuntrybasePrice(user?.base_price)} <small className="text-light ">
                      {" " + slectedCurrency?.symbol} </small></div>
                  </div>
                  {payStatus && (
                    <button
                      className="btn bg-warning fw-bold w-100 mt-2 JerseyAucBuy"
                      onClick={() => openModal(user.id)}
                      disabled={currentTime > bidEnd ? true : false}
                    >
                      <img src={Icon} alt="" className="mx-2 " height={18} />{" "}
                      Participate
                    </button>
                  )}
                  <AuctionModal
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    data={modalData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AuctionsTab;
